import React from "react";
import CustomSelect from "../../../components/CustomSelect/CustomSelect";
import {areaTypeOptions} from "../Elements/Settings/Settings";

const AreaModal = ({handleChange, localSettings, error}) => {
    return (
        <>
            <CustomSelect
                label="Area type"
                onChange={(selectedOption) => handleChange("areaType", selectedOption.value)}
                value={areaTypeOptions.find(option => option.value === (localSettings.areaType || "area-single"))}
                id="areaType"
                options={areaTypeOptions}
            />
            {error && <p className="error">{error}</p>}
        </>
    )
}

export default AreaModal;